<template>
  <client-only>
    <div class="feedback-page" :class="themeClasses">
      <!-- <div ref="navBar" class="nav-bar" :style="navBarStyle">
        <img src="@/assets/img/feedback/arrow-left.png" @click="onBack" />
        <span>意见反馈</span>
      </div> -->
      <div class="dialog-container">
        <VirtualList
          ref="dialogWindow"
          class="dialog-window"
          :style="dialogWindowStyle"
          :data-key="'id'"
          :data-sources="combineMessageList"
          :data-component="messageComponent"
          :extra-props="{ noHelpedList, theme }"
          page-mode
          @totop="onScrollTotop"
        >
          <div v-show="overflow" slot="header" class="load-header">
            <VanLoading v-show="!finished" type="spinner" size="24" />
          </div>
        </VirtualList>
      </div>
      <Editor
        ref="editor"
        :hot-word-list="hotWordList"
        :post="axiosPost"
        :user-id="userId"
        :business-id="businessId"
        :theme="theme"
        @input-focus="onFocusMsgInput"
        @send="onSendText"
        @send-hot-word="onSendHotWord"
        @send-file="onSendFile"
        @change-height="onChangeEditorHeight"
        @to-bottom="scrollToBottom"
      />
      <!-- <VanPopup
        v-if="businessId !== 5"
        v-model="showContactTooltip"
        :overlay="false"
        position="top"
        transition="van-fade"
      >
        <div class="contact-tooltip">
          请输入您的联系方式，让我们更好的为您服务～
        </div>
      </VanPopup> -->
    </div>
  </client-only>
</template>
<script>
import { v4 as uuidv4 } from 'uuid'
import unionBy from 'lodash/unionBy'
import pick from 'lodash/pick'
import intersectionBy from 'lodash/intersectionBy'
import xorBy from 'lodash/xorBy'
import VirtualList from 'vue3-virtual-scroll-list'
import Message from '@/components/feedback-m2u/Message'
import Editor from '@/components/feedback-m2u/Editor'
import crypto from '@/utils/crypto'
import device from '@/utils/device'
import { rem2px } from '@/utils/formatter'
import EventBus from '@/utils/event-bus'
import { invoke } from '@yoda/bridge'
import { messageOriginMap } from '@/utils/constant'

// js-bridge等ios全量之后才去掉
// import { ImagePreview, Loading, Toast, Popup, Dialog } from 'vant'
import {
  showImagePreview,
  showToast,
  showFailToast,
  showConfirmDialog,
  Loading,
  Popup,
  Dialog,
  Toast,
} from 'vant'
// // 避免网络差的情况下，icon显示不出来
// import 'vant/lib/icon/local.css'
// 目前在 nuxt 中无法按需引入样式，因此采用手动引入的方式
import 'vant/lib/index.css'
let pollInterval

export default {
  components: {
    Editor,
    VirtualList,
  },
  setup() {
    useHead({
      title: '智能客服',
      script: [{ src: '/js/flexible.js', type: 'text/javascript' }],
    })
  },
  data() {
    return {
      messageComponent: shallowRef(Message),
      businessId: '',
      deviceId: '',
      userId: '',
      bussVersion: '',
      platVersion: '',
      messageList: [],
      hotWordList: [],
      appInfo: {
        networkType: '',
        platform: '',
        platVersion: '',
        bussVersion: '',
        deviceMode: '',
      },
      isPolling: false,
      isLoadingMore: false,
      shouldScrollBottom: false,
      editorHeight: 0,
      overflow: false,
      finished: false,
      showKeyboard: false,
      navBarStyle: {},
      noHelpedList: [],
      timer: null,
      showContactTooltip: false,
      theme: ['white', 'ytPink'],
      host: '',
    }
  },
  computed: {
    dialogWindowStyle() {
      return {
        paddingBottom: `${this.editorHeight + rem2px(0.5)}px`,
      }
    },
    themeClasses() {
      const themes = Array.isArray(this.theme) ? this.theme : [this.theme]
      return themes.map((th) => `theme-${th}`)
    },
    /** 有些特殊情况需要自动模拟用户消息，比如type=4，需要帮助的情况 */
    combineMessageList() {
      const list = []
      this.messageList.forEach((source) => {
        list.push(source)

        if (source.type === 4 && source.showHelp) {
          list.push({ ...source, source: 1, type: 4.1 })
        }
      })
      return list
    },
  },
  created() {
    const nuxtApp = useNuxtApp()
    if (process.client) {
      const vueApp = nuxtApp.vueApp
      vueApp.use(Loading)
      vueApp.use(Popup)
      vueApp.use(Dialog)
      vueApp.use(Toast)
    }
    const config = useRuntimeConfig()
    this.host = config.public.VITE_YtFeedbackAPI
  },
  async mounted() {
    const { query } = this.$route
    console.log('==query==', query, this.$route)
    if (query?.theme) {
      this.theme = query.theme
    }
    this.navBarStyle = {
      marginTop: `${30}px`,
    }
    const businessOpts = { ky: 1, bigshot: 4, creator: 5, inch: 6, m2u: 7 }
    this.businessId = businessOpts[query.appId] || businessOpts.m2u
    // document.title = '智能客服'
    this.bussVersion = query.appVersion
    this.platVersion = query.platVersion

    window.addEventListener('resize', this.onResize)
    this.$nextTick(() => {
      this.$refs.dialogWindow.$el.addEventListener('touchmove', this.resetPopup)
      this.$refs.dialogWindow.$el.addEventListener('click', this.resetPopup)
      document.addEventListener('click', this.onClickBody)
    })
    EventBus.$on('send-question', this.onSendQuestion)
    EventBus.$on('view-image', this.onViewImage)
    EventBus.$on('no-help', this.onNoHelp)

    await this.getDeviceId()

    // 轮询消息列表
    this.$nextTick(() => {
      this.pollMessageList(true)
    })
    pollInterval = setInterval(this.pollMessageList, 1000)

    this.getHotWordList()

    this.initAppInfo()

    this.setRem()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)

    if (this.$refs.dialogWindow) {
      this.$refs.dialogWindow.$el.removeEventListener(
        'touchmove',
        this.resetPopup
      )
      this.$refs.dialogWindow.$el.removeEventListener('click', this.resetPopup)
    }

    EventBus.$off('send-question', this.onSendQuestion)
    EventBus.$off('view-image', this.onViewImage)
    EventBus.$off('no-help', this.onNoHelp)

    if (pollInterval) {
      clearInterval(pollInterval)
      pollInterval = null
    }
  },
  methods: {
    setRem() {
      const docEl = document.documentElement
      const width = docEl.getBoundingClientRect().width
      console.log({ width })

      if (width > 1200) {
        // 最大宽度
        width = 1200
      }
      const rem = (width * 100) / 750
      docEl.style.fontSize = rem + 'px'
    },
    onResize() {
      this.setRem()
    },
    axiosGet(url, params = {}) {
      const cryptoObj = crypto()
      return this.$request(`${this.host}${url}`, {
        params: {
          ...cryptoObj,
          bussId: this.businessId,
          deviceId: this.deviceId,
          did: this.deviceId,
          'ky.api_st': this.$cookie.get('ky.api_st') || '',
          userId: this.userId || '',
          ...params,
        },
        withCredentials: true,
      })
    },
    axiosPost(url, data = {}, params = {}, options = {}) {
      const cryptoObj = crypto()
      return this.$request.post(`${this.host}${url}`, data, {
        params: {
          ...cryptoObj,
          bussId: this.businessId,
          deviceId: this.deviceId,
          did: this.deviceId,
          'ky.api_st': this.$cookie.get('ky.api_st') || '',
          userId: this.userId || '',
          ...params,
        },
        withCredentials: true,
        ...options,
      })
    },
    async pollMessageList(first) {
      if (this.isPolling) {
        return
      }
      this.isPolling = true
      const isInitial = !this.messageList.length

      // 第一次进页面，获取最新消息
      if (isInitial) {
        this.shouldScrollBottom = true
      }

      const messageList = await this.getMessageList(
        isInitial ? { up: true } : {}
      )
      if (first && messageList && messageList.length < 10) {
        this.finished = true
      }

      if (this.shouldScrollBottom) {
        this.$nextTick(this.scrollToBottom)
      }
      this.isPolling = false
    },
    async getMessageList(info = {}) {
      const params = {
        up: false,
        limit: 10,
        ...info,
      }
      try {
        if (this.messageList.length && !params.id) {
          params.id = params.up
            ? this.messageList[0].id
            : this.messageList[this.messageList.length - 1].id
        }
        const res = await this.axiosGet(
          '/rest/n/fb/app/dialog/getMessage',
          params
        )
        if (res.result !== 1 || !res.list.length) {
          this.shouldScrollBottom = false
        }
        if (res.result === 1) {
          if (!params.up && res.list.some((item) => item.commonReply)) {
            this.handleContactTooltip()
          }
          return this.mergeMessageList(res.list, !params.up)
        }
      } catch (e) {
        this.shouldScrollBottom = false
      }
    },
    async getHotWordList() {
      try {
        const res = await this.axiosGet('/rest/n/fb/app/dialog/getHotWord')
        if (res.result === 1) {
          this.hotWordList = res.listV2
        }
      } catch (e) {}
    },
    async sendMessage(info) {
      info.messageOrigin = info.messageOrigin || messageOriginMap.Auto
      try {
        const res = await this.axiosPost(
          '/rest/n/fb/app/dialog/sendMessage',
          { extra: JSON.stringify({}), ...info },
          {
            contact: localStorage.getItem('feedback_user_contact') || '',
            bussVersion: this.bussVersion || this.appInfo.bussVersion,
            appver: this.bussVersion || this.appInfo.bussVersion,
            platVersion: this.platVersion || this.appInfo.platVersion,
            ...pick(this.appInfo, ['networkType', 'platform', 'deviceMode']),
          },
          { timeout: 10000 }
        )
        if (res.result === 1) {
          if (res.list.some((item) => item.commonReply)) {
            this.handleContactTooltip()
          }
          this.shouldScrollBottom = true
          this.mergeMessageList(res.list, true)
          this.$nextTick(this.scrollToBottom)
        }
        return res.result
      } catch (e) {
        if (e?.message === 'Network Error') {
          showFailToast('网络错误，请检查您的网络')
        } else if (e?.message?.includes?.('timeout')) {
          showFailToast('网络超时，请检查您的网络')
        }
      }
    },
    getDeviceInfoFromYoda(...args) {
      return new Promise((resolve, reject) => {
        invoke('system.getDeviceInfo').then((payload) => {
          console.log('=payload===', payload)
          if (payload && payload.sys) {
            resolve(payload)
          } else {
            reject(new Error('getDeviceInfoFromYoda failed'))
          }
        })
        setTimeout(reject, 500)
      })
    },
    getAppInfoFromYoda(...args) {
      return new Promise((resolve, reject) => {
        invoke('system.getAppInfo').then((payload) => {
          if (payload && payload.appver) {
            resolve(payload)
          } else {
            reject(new Error('getAppInfoFromYoda failed'))
          }
        })
        setTimeout(reject, 500)
      })
    },
    getNetworkTypeFromYoda(...args) {
      return new Promise((resolve, reject) => {
        invoke('system.getNetworkType').then((payload) => {
          if (payload && payload.net) {
            resolve(payload)
          } else {
            reject(new Error('getNetworkTypeFromYoda failed'))
          }
        })
        setTimeout(reject, 500)
      })
    },
    deviceInfoCompat() {
      if (device.isIOS) {
        Object.assign(this.appInfo, {
          platform: 2,
          platVersion: device.iosVersion,
        })
      } else if (device.isAndroid) {
        Object.assign(this.appInfo, {
          platform: 1,
          platVersion: device.androidVersion,
        })
      } else {
        this.appInfo.platform = 4
      }
      this.appInfo.deviceMode = device.model
    },
    appInfoCompat() {
      this.appInfo.bussVersion = device.appVersion
    },
    yodaCompat() {
      this.deviceInfoCompat()
      this.appInfoCompat()
    },
    initAppInfo() {
      if (device.isYt) {
        console.info('==isInYoda==')
        try {
          this.getDeviceInfoFromYoda({})
            .then(({ sys, mod }) => {
              const [platform, platVersion] = sys.split('_')
              Object.assign(this.appInfo, {
                platform: platform.toLowerCase() === 'android' ? 1 : 2,
                platVersion,
                deviceMode: mod,
              })
            })
            .catch(this.deviceInfoCompat)
          this.getAppInfoFromYoda({})
            .then(({ appver }) => {
              this.appInfo.bussVersion = appver
            })
            .catch(this.appInfoCompat)
          this.getNetworkTypeFromYoda({})
            .then(({ net }) => {
              this.appInfo.networkType =
                { WIFI: 1, MOBILE_4G: 2, MOBILE_3G: 3 }[net] || ''
            })
            .catch((e) => {})
        } catch (e) {
          console.info('==initAppInfo error==')
          this.yodaCompat()
        }
      } else {
        this.yodaCompat()
      }
    },
    async getDeviceId() {
      const { query } = this.$route
      let deviceId = Array.isArray(query.did) ? query.did[0] : query.did
      const uid = query.userId || query.user_id || ''
      this.userId = uid
      if (!deviceId && device.isYt) {
        try {
          console.info('yoda ready')
          const { did, userId } = await this.getAppInfoFromYoda()
          deviceId = did
          !uid && (this.userId = userId)
        } catch (e) {
          console.error('yoda get app info failed ')
        }
      }
      if (!deviceId) {
        deviceId = localStorage.getItem('feedback_deviceId')
      }
      if (!deviceId) {
        deviceId = uuidv4()
      }
      localStorage.setItem('feedback_deviceId', deviceId)
      this.deviceId = deviceId
    },
    async onSendText({ word: text, messageOrigin }) {
      const msg = text.trim()
      if (!msg) {
        return showToast('您输入的内容为空！')
      }
      if (msg.length > 500) {
        return showToast('最多仅支持输入500字！')
      }
      const res = await this.sendMessage({
        type: 1,
        content: msg,
        messageOrigin,
      })
      if (res === 1) {
        this.clearEditor()
      }
    },
    handleContactTooltip() {
      let time = localStorage.getItem('feedback_cotact_tooltip_time')
      if (time) {
        time = Number(time)
      }
      // 不展示填写联系方式的businessId列表
      const noContactId = [5]
      const now = Date.now()
      const isOverWeek = !time || now - time > 7 * 24 * 60 * 60 * 1000
      if (
        !localStorage.getItem('feedback_user_contact') &&
        isOverWeek &&
        !noContactId.includes(this.businessId)
      ) {
        localStorage.setItem('feedback_cotact_tooltip_time', now)
        this.showContactTooltip = true
      }
    },
    async onSendHotWord(w) {
      const info = { type: 1, content: w.word }
      await this.sendMessage(info)
    },
    onSendQuestion(question) {
      this.sendMessage({ type: 1, content: question })
    },
    onSendFile(info) {
      if (Array.isArray(info)) {
        info.forEach((it) => this.sendMessage(it))
        return
      }
      this.sendMessage(info)
    },
    clearEditor() {
      this.$refs.editor.clearInput()
    },
    scrollToBottom() {
      this.scrollToOffset(this.$refs?.dialogWindow?.getScrollSize?.())
      /**
       * vue-virtual-scroll-list的原因第一次滚动到底部不是很准确，需要再滚动一次
       * 但这好像又会导致ios端editor偶尔会消失，@FIXME
       * 注释下面这句话好像也不会出现滚动到底部不准确的问题了(2021-06-29，iphone8)。先这样处理，再观察
       */
      //   setTimeout(() => {
      //     this.scrollToOffset(this.$refs.dialogWindow.getScrollSize())
      //   }, 100)
      this.shouldScrollBottom = false
    },
    onFocusMsgInput() {
      console.log('onFocusMsgInput', device.isIOS)
      if (device.isIOS) {
        this.scrollToBottom()
      } else {
        setTimeout(this.scrollToBottom, 500)
      }
      this.showKeyboard = true
    },
    resetPopup() {
      this.showContactTooltip = false
    },
    async onScrollTotop() {
      if (this.isLoadingMore) {
        return
      }
      this.isLoadingMore = true
      const messageList = await this.getMessageList({ up: true })
      if (messageList && !messageList.length) {
        this.finished = true
      }
      if (messageList && messageList.length) {
        const ids = messageList.map((item) => item.id)
        this.$nextTick(() => {
          const dialogWindow = this.$refs.dialogWindow
          const offset = ids.reduce((prevValue, currentId) => {
            const prevSize =
              typeof prevValue === 'string'
                ? dialogWindow.getSize(prevValue)
                : prevValue
            return prevSize + dialogWindow.getSize(currentId)
          })
          this.scrollToOffset(offset)
          this.isLoadingMore = false
        })
      } else {
        this.isLoadingMore = false
      }
    },
    scrollToOffset(offset) {
      if (this.$refs.dialogWindow) {
        this.$refs.dialogWindow.scrollToOffset(offset)
      }
    },
    mergeMessageList(list, isNew) {
      const intersectionList = intersectionBy(list, this.messageList, 'id')
      const appendList = xorBy(list, intersectionList, 'id')
      if (isNew) {
        list.forEach((item) => {
          this.messageList.push(item)
        })
        this.messageList = unionBy(this.messageList, 'id')
      } else {
        list.reverse().forEach((item) => {
          this.messageList.unshift(item)
        })
        this.messageList = unionBy(this.messageList, 'id')
      }
      this.$nextTick(this.checkOverflow)
      return appendList
    },
    onChangeEditorHeight(h) {
      console.log('onChangeEditorHeight', h)
      this.editorHeight = h
      // 避免ios端输入框高度变化时坠落被键盘挡住
      this.$nextTick(() => {
        if (!this.timer) {
          this.timer = setTimeout(() => {
            this.scrollToOffset(this.$refs?.dialogWindow?.getScrollSize?.())
            this.timer = null
          }, 500)
        }
      })
    },
    onBack() {
      invoke('webview.exitWebView')
    },
    onViewImage(msg) {
      const imageMsgs = this.messageList.filter((item) => item.type === 2)
      const index = imageMsgs.findIndex((item) => item.id === msg.id)
      showImagePreview({
        images: imageMsgs.map((item) => item.content),
        startPosition: index,
        loop: false,
      })
    },
    checkOverflow() {
      if (this.$refs.dialogWindow) {
        this.overflow =
          this.$refs.dialogWindow?.getScrollSize?.() -
            this.$refs.dialogWindow?.getClientSize?.() >
          0
      } else {
        this.overflow = false
      }
    },
    async onNoHelp(msg) {
      const res = await this.axiosPost('/rest/n/fb/app/dialog/updateHelp', {
        id: msg.id,
        help: 2,
      })
      if (res.result === 1) {
        showToast('收到您的反馈，我们将会及时处理')
        this.noHelpedList.push(msg.id)
      }
    },
    onClickBody() {
      this.showContactTooltip = false
    },
  },
  head: {
    title: '',
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0',
      },
    ],
  },
}
</script>
<style lang="less">
@font-family-default: PingFangSC-Regular;
@contact-bar-height: 1.19rem;

@keyframes fade-enter {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fade-leave {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

html,
body {
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  // background-color: #dcdcdc;
}

.feedback-page {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  font-family: @font-family-default;
  font-size: 0.28rem;
  color: rgba(25, 25, 25, 1);
  background-color: #141414;

  .theme-white& {
    background-color: rgba(248, 248, 248, 1);
  }

  .nav-bar {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 0.74rem;
    background-color: #fff;
    z-index: 999;

    img {
      margin-left: 0.15rem;
      width: 0.6rem;
      height: 0.6rem;
    }

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-family: @font-family-default;
      font-weight: 700;
      font-size: 0.32rem;
      color: rgba(25, 25, 25, 0.9);
    }
  }

  #anchor {
    position: fixed;
    top: 0;
    left: 0;
    width: 4px;
    height: 4px;
    background-color: red;
    z-index: 1000;
  }

  .dialog-container {
    flex: 1;
    width: 100%;
    min-height: 100%;
    margin-top: @contact-bar-height + 0.2rem;

    .theme-white& {
      margin-top: 0.6rem;
    }

    &-creator {
      margin-top: 0.34rem;
    }

    .van-dialog {
      background-color: #222;
    }

    .van-dialog__header {
      color: rgba(255, 255, 255, 0.9);
    }

    .van-dialog__confirm {
      background-color: #222;
      //border: red 1px solid;
    }

    .van-dialog__cancel {
      background-color: #222;
    }

    .van-hairline--left::after {
      border-color: #2f2f2f;
    }

    .van-hairline--top::after {
      border-color: #2f2f2f;
    }
  }

  .dialog-window {
    flex: 1;
    padding: 0 0.34rem;
    width: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    background-color: #141414;

    .theme-white& {
      background-color: unset;
    }
  }

  .load-header {
    display: flex;
    justify-content: center;
    padding: 0.1rem 0;

    .no-more {
      color: rgba(25, 25, 25, 0.3);
      // color: #b9b9b9;
      font-size: 0.24rem;
    }
  }
}

.van-toast {
  &.toast__long-text {
    width: 50%;
  }
}

.van-popup.van-popup--top {
  padding-top: @contact-bar-height + 0.1rem;
  background-color: transparent;
  pointer-events: none;

  .contact-tooltip {
    margin-left: 2.56rem;
    padding: 0.37rem 0.3rem 0;
    width: 4.12rem;
    height: 1.42rem;
    font-size: 0.26rem;
    line-height: 0.36rem;
    color: rgba(0, 0, 0, 0.9);
    background-image: url('../../assets/img/feedback/popover-bg.png');
    background-size: cover;
  }
}
</style>
